/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUserLabTestItem } from 'app/shared/model/user-lab-test-item.model';
import { IOrganism } from 'app/shared/model/organism.model';
import { IAntibiotic } from 'app/shared/model/antibiotic.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IPatientOrganismAntibioticSusceptibility {
  id?: string;
  zoneOfInhibition?: number | null;
  mic?: number | null;
  mbc?: number | null;
  testDate?: number;
  virulenceFactors?: string | null;
  resistanceMechanisms?: string | null;
  morphology?: string | null;
  growthConditions?: string | null;
  notes?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  recommended?: boolean | null;
  patientLabTestItem?: IUserLabTestItem | null;
  organism?: IOrganism | null;
  antibiotic?: IAntibiotic | null;
  sensitivity?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IPatientOrganismAntibioticSusceptibility> = {
  active: false,
  recommended: false,
};
